var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/react-css-modules/~/lodash/_Symbol.js
// module id = 210
// module chunks = 0